import { HorizontalScrollView } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { isEmpty } from "lodash";

import { type VisitWithCaseData } from "../../types";
import { MissingDocumentsInnerCards } from "./MissingDocumentsInnerCard";

interface VisitBottomSheetInnerCardCarouselProps {
  visit: VisitWithCaseData;
}

export function VisitBottomSheetInnerCardCarousel(props: VisitBottomSheetInnerCardCarouselProps) {
  const { visit } = props;

  if (!isDefined(visit)) {
    return null;
  }

  const { missingRequirements = [] } = visit.attributes;
  return (
    <HorizontalScrollView stretch sx={{ height: "max-content", "&:not(:empty)": { pt: 7, pb: 3 } }}>
      {isDefined(missingRequirements) && !isEmpty(missingRequirements) && (
        <MissingDocumentsInnerCards missingRequirements={missingRequirements} />
      )}
    </HorizontalScrollView>
  );
}
